import { render, staticRenderFns } from "./ProviderGridModal.vue?vue&type=template&id=08b56482&"
import script from "./ProviderGridModal.vue?vue&type=script&lang=js&"
export * from "./ProviderGridModal.vue?vue&type=script&lang=js&"
import style0 from "./ProviderGridModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports